export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.9-1222.33",
  commitId: "91a8d09ed9dfc753767cb238227ecdeb790491f9",
  commitTime: "2026-09-09T12:22:33.000Z",
});
